import { render, staticRenderFns } from "./LiveSport.vue?vue&type=template&id=f52122ea&"
import script from "./LiveSport.vue?vue&type=script&lang=js&"
export * from "./LiveSport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports